import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalController, AlertController, NavController, ToastController, LoadingController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';

import { Project } from '../../models/Project';

import { ProjectService } from '../../providers/project-service/project-service';

import { CreateProjectPage } from '../../pages/create-project/create-project.page';
import { Location } from '@angular/common';

import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { ProjectMember } from 'src/app/models/ProjectMember';
import { AuthService } from 'src/app/providers/auth-service/auth-service';
import { HttpClient } from '@angular/common/http';
import { Account } from 'src/app/models/Account';
import { TranslationBridge } from 'src/app/providers/translation-bridge/translation-bridge';
import { NotificationService } from 'src/app/providers/notification-service/notification-service';
import { NotificationMessage } from 'src/app/components/notification-message/notification-message.component';
import { StripeService } from 'src/app/providers/stripe-service/stripe-service';

import * as confetti from 'canvas-confetti';
import { InstitutionService } from 'src/app/providers/institution-service/institution-service';

//     let allowedRoles = ["owner", "member", "banking", "integrator"];

const INVITEROLES = [
  {
    value: 'member',
    title: 'Member',
    icon: 'assets/icons/phos/user-duotone.svg',
    subtitle: 'Volles Teammitglied, hat Zugriff auf Bankkonten als auch Integrationen. Kann keine Mitglieder einladen.'
  },
  {
    value: 'banking',
    title: 'Banking (coming soon)',
    disabled: true,
    icon: 'assets/icons/phos/bank-duotone.svg',
    subtitle: 'Kann Bankkonten hinzufügen und verwalten, Umsätze abholen und Transaktionen einsehen.'
  },
  {
    value: 'integrator',
    title: 'Integrator (coming soon)',
    disabled: true,
    icon: 'assets/icons/phos/atom-duotone.svg',
    subtitle: 'Kann Integrationen anlegen und verwalten. Sieht keine Transaktionsdaten.'
  },
  {
    value: 'owner',
    title: 'Administrator',
    icon: 'assets/icons/phos/crown-duotone.svg',
    subtitle: 'Kann alle Projekteinstellungen bearbeiten, die Subscription verwalten und Mitglieder einladen.'
  }
];

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {

  project: Project;
  taintedProject: Project;

  loading: boolean = true;
  editMode: boolean = false;
  formErrors: any;

  copySuccess: boolean = false;

  loadingMembers: boolean = true;
  members: ProjectMember[] = [];

  inviteModalOpen: boolean = false;
  
  loadingInvites: boolean = false;
  invitesList: any = [];

  messages: NotificationMessage[] = [];

  linkPaymentMethodsLoading: boolean = false;

  constructor(
    public authService: AuthService,
    private http: HttpClient,

    public modalController: ModalController,
    public alertController: AlertController,
    public projectService: ProjectService,
    private activatedRoute: ActivatedRoute,
    private toastController: ToastController,
    private loadingController: LoadingController,
    private translate: TranslationBridge,
    private navCtrl: NavController,
    private stripeService: StripeService,
    private notificationService: NotificationService,
    private institionService: InstitutionService,
    private elementRef: ElementRef,
    private location: Location) { }

  ngOnInit() {
    this.loadProject().then((project) => {
      if(!this.project.isFilled){
        this.navigate(':projectId/setup', null);
      }

      this.getProjectRelatedMessages();

      // check if we have returnFrom=success GET parameter angular way
      const returnFrom = (this.activatedRoute.snapshot.queryParams['returnFrom'] || "").toLowerCase();

      if(returnFrom == "checkout"){
        this.toastController.create({
          message: this.translate.get('ALERT_PROJECT_CHECKOUT_SUCCESS'),
          duration: 12000,
          position: 'top',
          cssClass: 'toast-success',
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        }).then((toast) => {
          toast.present();
        });

        // PArTY!
        setTimeout(() => {
          const partyCanvas = this.elementRef.nativeElement.querySelector("#confetti-canvas");
          
          if(partyCanvas){        
            partyCanvas.classList.add("active");
            var confettiCannon = confetti.create(partyCanvas, {
              resize: true,
              useWorker: true
            });
            for(let i = 0; i < 10; i++){
              setTimeout(() => {

                confettiCannon({
                  particleCount: 100,
                  startVelocity: 32,
                  spread: 360,
                  origin: {
                    x: Math.random(),
                    y: Math.random() - 0.2
                  }
                });
              }, i * 300);
            }
              setTimeout(() => {
                partyCanvas.classList.remove("active");
              }, 10000);
          }
        }, 1000);


      }
      if(returnFrom == "canceledsubscription"){
        this.toastController.create({
          message: this.translate.get('ALERT_PROJECT_SUBSCRIPTION_CANCELED'),
          duration: 12000,
          position: 'top',
          cssClass: 'toast-warning',
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        }).then((toast) => {
          toast.present();
        });
      }
      if(returnFrom == "updatesubscription" || returnFrom == "updatedsubscription"){
        this.toastController.create({
          message: this.translate.get('ALERT_PROJECT_CHECKOUT_SUCCESS'),
          duration: 12000,
          position: 'top',
          cssClass: 'toast-success',
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        }).then((toast) => {
          toast.present();
        });
      }

    });
  }

  loadProject() {
    return new Promise(async (resolve, reject) => {
      let projectId = this.activatedRoute.snapshot.paramMap.get('projectId');
      let currentUrl = "/dashboard";

      this.project = this.projectService.getCurrentProject();
      this.projectService.isReady().then(() => {
        this.projectService.getLastOpenedProject().then((lastOpenedProject) => {

          if (this.project && this.project.id == projectId) { // current Project was set
            this.reloadMembers();
            return resolve(this.project);
          }

          if (projectId) {
            this.projectService.setCurrentProject(projectId).then(() => {
              this.project = this.projectService.getCurrentProject();
              this.loading = false;

              this.reloadMembers();

              this.getProjectRelatedMessages();

              return resolve(this.project);
            });
          } else if (!projectId) {

            if (lastOpenedProject?.id) { // get the last opened project
              this.projectService.setCurrentProject(lastOpenedProject.id).then(() => {
                this.project = this.projectService.getCurrentProject();
                this.location.replaceState(this.projectService.currentProject.id + currentUrl);
                this.loading = false;

                this.reloadMembers();

                return resolve(this.project);
              });

            } else {
              // no Project Created yet
              this.navigate(':projectId/setup', null);
              this.loading = false;
              return resolve(this.project);
            }

          }

        });
      });
    });
  }

  reloadMembers(){
    this.project = this.projectService.getCurrentProject();
    this.projectService.getProjectMembers(this.project).then((members) => {
      this.members = members;
      this.loadingMembers = false;
    });
  }

  navigate(path: string, event: any) {
    if (this.projectService.currentProject?.id && path.indexOf(':projectId') != -1) {
      this.navCtrl.navigateForward(path.replace(':projectId', this.projectService.currentProject?.id), {
        animated: false
      });
    } else {
      this.navCtrl.navigateForward('/' + path, {
        animated: false
      });
    }
    if(event){
      event.stopPropagation();
      event.preventDefault();
    }
    return false;
  }

  ionViewDidEnter() {
  
  }

  async getProjectRelatedMessages(){
    this.messages = [];

    console.log(this.project.status);

    if(this.project.status == 'incomplete_expired'){
      this.messages.push({
        type: "warning",
        icon: "warning",
        title: "Projekt nicht vollständig",
        text: this.translate.get("DASHBOARD_MESSAGES_INCOMPLETE_EXPIRED"),
        actionTitle: this.translate.get("DASHBOARD_MESSAGES_INCOMPLETE_EXPIRED_ACTION"),
        action: () => {
          this.navigate(':projectId/upgrade', null);
        }
      });
    }

    if(this.project.status == 'incomplete'){
      this.messages.push({
        type: "warning",
        icon: "warning",
        title: "Projekt nicht vollständig",
        text: this.translate.get("DASHBOARD_MESSAGES_INCOMPLETE"),
        actionTitle: this.translate.get("DASHBOARD_MESSAGES_INCOMPLETE_ACTION"),
        action: () => {
          this.enterBilling();
        }
      });
    }

    if(!this.projectService.isProjectActive()){
      if(this.project.isSubscribed){
        this.messages.push({
          type: "warning",
          icon: "warning",
          title: "Projekt nicht aktiv",
          text: this.translate.get("DASHBOARD_MESSAGES_INACTIVE_SUBSCRIBED"),
          actionTitle: this.translate.get("DASHBOARD_MESSAGES_INACTIVE_SUBSCRIBED_ACTION"),
          action: () => {
            this.enterUpgrade();
          }
        });
      } else {
        this.messages.push({
          type: "accent",
          icon: "hourglass-low",
          title: "Projekt nicht aktiv",
          text: this.translate.get("DASHBOARD_MESSAGES_INACTIVE_NEW"),
          actionTitle: this.translate.get("DASHBOARD_MESSAGES_INACTIVE_NEW_ACTION"),
          action: () => {
            this.enterUpgrade();
          }
        });        
      }
    }

    // check open tasks
    this.notificationService.getTaskFeed(this.project.id).then((tasks: any) => {
      console.log(tasks);
    });
      
    // check connected accounts
    let accounts = this.projectService.getCachedAccounts();
    if(accounts.length > 0){
      let outdatedAccounts = this.institionService.getOutdatedAccountsFromList(accounts);
      if(outdatedAccounts.length > 0){
        this.messages.push({
          type: "warning",
          icon: "bank",
          title: "Bankkonten",
          text: this.translate.get("DASHBOARD_MESSAGES_OUTDATED_ACCOUNTS").replace("$COUNT",outdatedAccounts.length),
          actionTitle: this.translate.get("DASHBOARD_MESSAGES_OUTDATED_ACCOUNTS_ACTION"),
          action: () => {
            this.navigate(':projectId/bank-accounts', null);
          }
        });
      }

    }
  }
  
  /*
    Invite Management
  */
  openInviteModal() {
    this.invitesList = [{
      email: "",
      role: "member"
    }];
    this.inviteModalOpen = true;
  }
  closeInviteModal() {
    this.inviteModalOpen = false;
  }
  onModallDismiss() {
    this.inviteModalOpen = false;
  }
  addInvite() {
    this.invitesList.push({
      email: "",
      role: "member"
    });
  }
  removeInviteRow(index) {
    this.invitesList.splice(index, 1);
  }
  onInviteRoleChanged(event, index) {
    this.invitesList[index].role = event.value;
  }

  async sendInvites() {
    return new Promise(async (resolve, reject) => {
      this.loadingInvites = true;
      let hadError = false;
      // send them each with a delay of 1 second
      for (var i = 0; i < this.invitesList.length; i++) {
        let invite = this.invitesList[i];
        if (invite.email && invite.role) {
          // wait between each invite 1 second
          await new Promise(resolve => setTimeout(resolve, 400));

          await this.projectService.inviteMember(this.project, invite.email, invite.role).then((result) => {
            // remove on success
            if (result) this.invitesList.splice(i, 1);
          }).catch((error) => {
            hadError = true;
            // provide error
            this.toastController.create({
              message: (error.error.message ? error.error.message : error),
              duration: 5000,
              position: 'top',
              cssClass: 'toast-error',
              buttons: [
                {
                  text: 'OK',
                  role: 'cancel',
                  handler: () => {
                  }
                }
              ]
            }).then((toast) => {
              toast.present();
            });

          });
        }
      }

        this.loadingInvites = false;

        if (!hadError) {
          this.inviteModalOpen = false;
          // provide message
          this.toastController.create({
            message: "Einladungen wurden versendet.",
            duration: 5000,
            position: 'top',
            cssClass: 'toast-success',
            buttons: [
              {
                text: 'OK',
                role: 'cancel',
                handler: () => {
                }
              }
            ]

          }).then((toast) => {
            toast.present();
          });
        }
        return resolve(true);

    });
  }

  public getInviteRoles(){
    return INVITEROLES;
  }

  public async copyWorkspaceId(ev: any){
    ev.stopPropagation();
    ev.preventDefault();
  
    // copy to clipboard via navigator
    navigator.clipboard.writeText(this.project.id).then(() => {
      this.toastController.create({
        message: 'Copied to clipboard!',
        duration: 2000,
        position: 'top'
      }).then((toast) => {
        toast.present();
      });
    }).catch((err) => {
      this.toastController.create({
        message: 'Couldn\'t copy to clipboard.',
        duration: 2000,
        position: 'top'
        }).then((toast) => {
          toast.present();
        });
      });
  }

  /*
    Edit Mode
  */
  enterEdit(){
    this.taintedProject = JSON.parse(JSON.stringify(this.projectService.getCurrentProject()));
    this.editMode = true;
    this.loading = false;
  }
  handleNewProjectIcon(icon: string){
    this.taintedProject.icon = icon;
  }

  cancelEdit(){
    this.taintedProject = JSON.parse(JSON.stringify(this.projectService.getCurrentProject()));
    this.editMode = false;
  }
  saveEdit(){
    this.projectService.updateProjectById(this.project.id,this.taintedProject).then((project) => {
      this.loading = false;
      this.editMode = false;
    }).catch((error) => {
      this.loading = false;
      this.toastController.create({
        message: (error.error.message ? error.error.message : error),
        duration: 5000,
        position: 'top',
        cssClass: 'toast-error',
        buttons: [
          {
            text: 'OK',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      }).then((toast) => {
        toast.present();
      });
    });;
  }

  /*
    Enter Pages
  */
  enterUpgrade(){
    this.navigate(':projectId/upgrade', null);
  }
  enterBilling(){
    this.linkPaymentMethodsLoading = true;
    this.stripeService.getCustomerPortalLink(this.project.id).then((result) => {
      window.open(result.url, '_blank');
      this.linkPaymentMethodsLoading = false;
    }).catch((error) => {
      this.linkPaymentMethodsLoading = false;
      this.toastController.create({
        message: (error.error.message ? error.error.message : error),
        duration: 5000,
        position: 'top',
        cssClass: 'toast-error',
        buttons: [
          {
            text: 'OK',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      }).then((toast) => {
        toast.present();
      });
    });
  }

  /*
    Update bank accounts
  */
  async updateAccounts(){
    let alert = await this.alertController.create({
      header: 'Kontoflux.io holt die Umsätze automatisch ab.',
      message: 'Solltest du den Eindruck haben, dass deine Umsätze nicht aktuell sind, kannst du hier eine manuelle Aktualisierung anstoßen.',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
          },
        },
        {
          text: 'Umsätze abholen',
          handler: () => {
            this.projectService.triggerAction(this.project, "import");
          }
        }
      ],
    });
    await alert.present();
  }

  /*
    Update bank accounts
  */
  async deleteProject(){
      let alert = await this.alertController.create({
        header: this.translate.get('ALERT_DELETE_PROJECT_TITLE'),
        message: this.translate.get('ALERT_DELETE_PROJECT_INFO'),
        inputs: [
          {
            name: 'confirm',
            type: 'text',
            placeholder: this.translate.get('ALERT_DELETE_PROJECT_CONFIRM_TEXT'),
            value: '',
            handler: async () => {
            },
          }
        ],
        buttons: [
          {
            text: this.translate.get('CANCEL'),
            role: 'cancel',
            handler: () => {
            },
          },
          {
            text: this.translate.get('ALERT_DELETE_PROJECT_CONFIRM'),
            role: 'descructive',
            handler: async (data: any) => {
              // check if confirm text is correct
              if(data.confirm == this.translate.get('ALERT_DELETE_PROJECT_CONFIRM_TEXT')){

              let loader = await this.loadingController.create({
                message: this.translate.get('ALERT_DELETE_PROJECT_CONFIRM'),
                duration: 60000,
              });
              await loader.present();
                this.projectService.deleteProjectById(this.project.id).then((result) => {
                  loader.dismiss();
                  setTimeout(() => {
                      // navigate to dashboard with hard reload
                      window.location.href = "https://" + environment.productBackend + "/dashboard";
                  }, 2000);
                  this.toastController.create({
                    message: this.translate.get('ALERT_DELETE_PROJECT_DELETION_SUCCESS'),
                    duration: 5000,
                    position: 'top',
                    cssClass: 'toast-success',
                    buttons: [
                      {
                        text: 'OK',
                        role: 'cancel',
                        handler: () => {
                          // navigate to dashboard with hard reload
                          window.location.href = "https://" + environment.productBackend + "/dashboard";
                        }
                      }
                    ]
                  }).then((toast) => {
                    toast.present();
                  });
                });
              } else {
                this.toastController.create({
                  message: this.translate.get('ALERT_DELETE_PROJECT_CONFIRM_ERROR'),
                  duration: 5000,
                  position: 'top',
                  cssClass: 'toast-error',
                  buttons: [
                    {
                      text: 'OK',
                      role: 'cancel',
                      handler: () => {
                      }
                    }
                  ]
                }).then((toast) => {
                  toast.present();
                });
              }
            }
          }
        ],
      });
      await alert.present();
    }

}
